export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-instagram-2ceb8e49f72faa899b8a0f2fb7b1a526.svg";